import { AxiosResponse } from 'axios';
import {
  IGetSorisQrCodeRequest,
  ISORISOrderNumberBarcodeRequest,
  ISORISOrderNumberBarcodeResponse,
  ISORISQrCodeResponse,
} from '../../models/soris';
import { apiBase } from '../axios-client';

export const RETURN_PATH = `/customer/returns/v1`;
const OMS_PATH = '/oms/customer/order/v1';
const GET_SORIS_QR_CODE = `${RETURN_PATH}/sorisqrcode`;
const GET_SORIS_ORDER_NUMBER_BARCODE = `${OMS_PATH}/orderlookupbarcode`;

export const getSorisQrCode = (requestData: IGetSorisQrCodeRequest) => {
  return apiBase
    .post(GET_SORIS_QR_CODE, requestData)
    .then((response: AxiosResponse<ISORISQrCodeResponse>) => {
      // this doesn't catch a 200 response with an error in the body, but that shouldn't happen.
      if (response.data && response.data?.sorisQrImg) {
        return response.data;
      }
      throw new Error('No data found');
    });
};

export const getSorisOrderNumberBarcode = (
  requestDate: ISORISOrderNumberBarcodeRequest,
) => {
  return apiBase
    .post(`${GET_SORIS_ORDER_NUMBER_BARCODE}`, requestDate)
    .then((response: AxiosResponse<ISORISOrderNumberBarcodeResponse>) => {
      if (response.data) {
        return response.data;
      }
      throw new Error('No data found');
    });
};
